import React__default from 'react';
import { clsx } from 'clsx';

const badge = "_badge_1xm4m_1";
const styles = {
	badge: badge
};

const Badge = ({ className, variant = "neutral-stronger", children }) => {
  return React__default.createElement("span", { className: clsx(styles.badge, className), "data-variant": variant, "data-zds": true }, children);
};

export { Badge };
//# sourceMappingURL=Badge.es.js.map
